(function () {
  function initDesktopMegaHover() {
    var mq = window.matchMedia('(min-width: 992px)');

    function bind() {
      document.querySelectorAll('.has-megamenu').forEach(function (li) {
        var menu = li.querySelector('.sp-megamenu');
        if (!menu || li.dataset.spMegaHoverBound === '1') return;
        li.dataset.spMegaHoverBound = '1';

        var closeTimer;

        function clearClose() {
          if (closeTimer) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
          }
        }

        function armClose() {
          if (!mq.matches) return;
          clearClose();
          closeTimer = window.setTimeout(function () {
            li.classList.remove('is-mega-hover');
            closeTimer = null;
          }, 280);
        }

        function closeOtherMegas(except) {
          document.querySelectorAll('.has-megamenu.is-mega-hover').forEach(function (el) {
            if (el !== except) el.classList.remove('is-mega-hover');
          });
        }

        li.addEventListener('mouseenter', function () {
          if (!mq.matches) return;
          clearClose();
          closeOtherMegas(li);
          li.classList.add('is-mega-hover');
        });

        menu.addEventListener('mouseenter', function () {
          if (!mq.matches) return;
          clearClose();
          closeOtherMegas(li);
          li.classList.add('is-mega-hover');
        });

        li.addEventListener('mouseleave', armClose);
        menu.addEventListener('mouseleave', armClose);
      });
    }

    function onMqChange() {
      document.querySelectorAll('.has-megamenu.is-mega-hover').forEach(function (li) {
        li.classList.remove('is-mega-hover');
      });
    }

    bind();

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
    } else {
      mq.addListener(onMqChange);
    }
  }

  function initMobileDrawer() {
    var collapse = document.getElementById('collapsibleNavbar');
    if (!collapse) return;

    function setNavScrollLock(on) {
      var v = on ? 'hidden' : '';
      document.documentElement.style.overflow = v;
      document.body.style.overflow = v;
    }

    collapse.addEventListener('shown.bs.collapse', function () {
      if (window.innerWidth < 992) setNavScrollLock(true);
    });

    collapse.addEventListener('hidden.bs.collapse', function () {
      setNavScrollLock(false);
      document.querySelectorAll('.has-megamenu.mega-parent-show').forEach(function (li) {
        li.classList.remove('mega-parent-show');
      });
    });

    collapse.addEventListener('click', function (e) {
      if (e.target === collapse) {
        document.querySelector('.navbar-toggler[data-bs-target="#collapsibleNavbar"]')?.click();
      }
    });

    var sheet = collapse.querySelector('.sp-mobile-panel__sheet');
    if (sheet) {
      sheet.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    document.querySelectorAll('[data-sp-close-menu]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelector('.navbar-toggler[data-bs-target="#collapsibleNavbar"]')?.click();
      });
    });
  }

  function init() {
    initMobileDrawer();
    initDesktopMegaHover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
